/**
 * Copyright 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  FilterComparisonOperator,
  PlansFilterByFields,
  PlansFilterByInput,
} from "~/generated/graphql";
import { isEmpty, isNotEmpty, isNotNil } from "~/tools";
import { createFilterByInput } from "~/utils/createFilterByInput";
import { QueryGetPlans } from "./constants";

const isQueryStateDate = (queryState: QueryGetPlans): boolean => {
  return (
    isNotNil(queryState.startDateUTC) &&
    isNotEmpty(queryState.startDateUTC) &&
    isNotNil(queryState.endDateUTC) &&
    isNotEmpty(queryState.endDateUTC)
  );
};

export const preparePlansFilterBy = (
  queryState: QueryGetPlans
): PlansFilterByInput[] | undefined => {
  const createdAtFilter = isQueryStateDate(queryState)
    ? [
        {
          field: PlansFilterByFields.CreatedAt,
          operator: FilterComparisonOperator.Ge,
          values: [queryState.startDateUTC ?? ""],
        },
        {
          field: PlansFilterByFields.CreatedAt,
          operator: FilterComparisonOperator.Le,
          values: [queryState.endDateUTC ?? ""],
        },
      ]
    : [];

  const planStatusesFilter = createFilterByInput<PlansFilterByFields>(
    PlansFilterByFields.Status,
    queryState.planStatuses,
    queryState.excludePlanStatuses
  );

  const planActionIdsFilter = createFilterByInput<PlansFilterByFields>(
    PlansFilterByFields.ActionId,
    queryState.planActionIds,
    queryState.excludePlanActionIds
  );

  const planScheduleOptionsFilter = createFilterByInput<PlansFilterByFields>(
    PlansFilterByFields.ScheduleOption,
    queryState.scheduleOptions,
    queryState.excludeScheduleOptions
  );

  const retVal = [
    ...createdAtFilter,
    ...planStatusesFilter,
    ...planActionIdsFilter,
    ...planScheduleOptionsFilter,
  ];

  return isEmpty(retVal) ? undefined : retVal;
};
